export default {
    carbonCredit: {
        view: 'View',
        edit: 'Edit',
        back: 'Back',
        preview: 'Preview',
        confirm: 'Confirm',
        cancel: 'Cancel',
        dashboard: 'Dashboard',
        select: 'Select',
        submit: 'Submit',
        save: 'Save',
        title: 'Carbon Credit',
        projects: 'Projects',
        carbonProjectCredits: 'Carbon Project Credits',
        carbonCreditProjects: 'Carbon Credit Projects',
        exportAs: 'Export as',
        downloadAsCSV: 'Download as CSV',
        downloadAsExcel: 'Download as Excel',
        downloadAsPDF: 'Download as PDF',
        registerNewProject: 'Register New Project',  
        creditInfo: '*This is approximate number of credits. Actual number of credits might be different after verification.',
        search: 'Search',
        projectTitle: 'Project Title',
        projectType: 'Project Type',
        country: 'Country',
        totalCreditsGenerated: 'Total Credits Generated',
        status: 'Status',
        descriptionPlaceholder: "Please provide description of the project including goals",
        filePreviewNotAvailable: 'File preview is not available for this file type',
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending',
        proposed: 'Proposed',
        planned: 'Planned',
        inProgress: 'In Progress',
        operational: 'Operational',
        deactivated: 'Deactivated',
        avoidedDeforestation: 'Avoided Deforestation',
        agroForestry: 'Agroforestry',
        forestry: 'Forestry',
        regenerativeAgriculture: 'Regenerative Agriculture',
        agroforestry: 'Agroforestry',
        regenerative_agriculture: 'Regenerative Agriculture',
        projectDeletedSuccessfully: 'Project deactivated successfully',
        projectUpdatedSuccessfully: 'Project updated successfully',
        projectRegisteredSuccessfully: 'Project registered successfully',
        deactivateProjectError: 'Error deactivating project',
        deactivate: 'Deactivate',
        deactivateProject: 'Deactivate Project',
        deactivateConfirmation: 'Are you sure you want to deactivate this project?',
        activateProjectError: 'Error activating project',
        activate: 'Activate',
        activateProject: 'Activate Project',
        activateConfirmation: 'Are you sure you want to activate this project?',
        projectActivatedSuccessfully: 'Project activated successfully',
        registerProject: 'Register a New Project',
        editProject: 'Edit Project',

        register: { 
            companyName: 'Company Name',
            companyAddress: 'Company Address',
            web: 'Website',
            title: 'Register a Project',
            editTitle: 'Edit project',
            projectTitle: 'Project Title',
            projectType: 'Project Type',
            description: 'Description',
            selectCountry: "Select Country",
            selectOrganization: 'Select Organizations',
            status: 'Status',
            creditType: 'Credit Type',
            creditStart: 'Credit Start',
            creditEnd: 'Credit End',
            standardMethodology: 'Standard/Methodology',
            registerName: 'Register Name',
            validator: 'Validator',
            registryUrl: 'Registry URL',
            firstVerifier: 'First Verifier',
            validationDocumentation: 'Validation Documentation',
            vintage: 'Vintage',
            currency: 'Currency',
            projectInfo: 'Project Info',
            organizationDetails: 'Organizations Details',
            attachmentTitle: 'Attachment(s)',
            attachmentInfo: 'You can add any additional documents, images, video and audio files relevant to the project',
            documentation: 'Documentation',
            sdgsTitle: 'Sustainable Development Goals (SDGs)',
            sdgsInfo: 'Please select only the goals relevant to this specific project. The organizations will have access to view only the goals linked to this project.',
            dataCollectionTitle: 'Data Collection Cycle',
            dataCollectionInfo: 'To participate in the Carbon Credit Program, farmers must provide historical farm data during enrollment and continue submitting periodic data updates for as long as the program remains active. This ensures accurate tracking of carbon performance over time.',
            vintageYear: 'Vintage Year',
            estimatedCredit: 'Estimated Credits',
            pricePerCredit: 'Price Per Credit',
            moduleName: 'Module Name',
            futureData: 'Future Recurring Data Collection',
            score: 'Score',
            approval: 'Approval',

            projectAgreement: 'Project Agreement',
            headerImage: 'Header Image',
            headerImageInfo: '(Header image size 1920 x 420 pixels. Default image will be replaced with new image you upload)',
            headerImagePlaceholder: "Default Header Image",
            responsibleDimitraOffice: 'Responsible Dimitra Office',
            selectDimitraOffice: 'Select Dimitra Office',
            makeASelection: 'Make a Selection',
            addNewDimitraOffice: 'Add New Dimitra Office',
            editDimitraOffice: 'Edit Dimitra Office',
            officeName: 'Office Name',
            contactPerson: 'Contact Person Name',
            phoneNumber: 'Phone Number',
            email: 'Email',
            address: 'Address',
            officeNameRequired: 'Office name is required',
            contactPersonRequired: 'Contact person name is required',
            addressRequired: 'Address is required',
            phoneNumberRequired: 'Phone number is required', 
            phoneNumberInvalid: 'Phone number is invalid',
            phoneNumberLength: 'Phone number must be at least 10 digits long',
            selectVintage: 'Select Vintage',
            officeAddedSuccessfully: 'Dimitra office added successfully',
            errorAddingOffice: 'Error adding Dimitra office',
            searchOrganizations: 'Search Organizations',
            searchOrganizationsPlaceholder: 'Search by organization name...',
            noOrganizationsFound: 'No organizations found',
            loadingOrganizations: 'Loading organizations...',
            selectedOrganizations: 'Selected Organizations',
            errorNegative: 'cannot be negative.',
            errorRequiredField: '{field} is required.',
            errorOrganizationRequired: 'At least one organization must be selected.',
            errorVintageRequired: 'At least one vintage entry is required.',
            errorVintageFieldsRequired: 'All vintage fields (year, credits, price) are required.',
            allOrganizations: 'All Organizations',
            removal: 'Removal',
            avoided: 'Avoided',
            mandatory: 'Mandatory',
            scoreValidationError: 'Invalid score for module "{module}". Score must be a whole number 0 or greater.',
            approvalValidationError: 'Invalid approval for module "{module}". Approval must be a whole number between 0 and 100.',
            saveError: 'Failed to save project',
            fileUploadFailed: 'File Upload Failed',
            unsupportedFileFormat: 'Unsupported file format',
            errorUploadingFile: 'Error uploading file',
            scoreError: {
                invalid: 'Score must be a valid number',
                range: 'Score must be 0 or greater',
                wholeNumber: 'Score must be a whole number'
            },
            approvalError: {
                invalid: 'Approval must be a valid number',
                range: 'Approval must be between 0 and 100',
                wholeNumber: 'Approval must be a whole number'
            },
            selectStatus: 'Select Status',
            selectCreditType: 'Select Credit Type',
            dateFormat: 'dd/mm/yyyy',
            standardPlaceholder: 'Standard',
            browse: 'Browse',
            currencyPlaceholder: 'USD',
                    selectFile: 'Select File',
        dragDropFiles: 'Drag & Drop files here',
        hideDetails: 'Hide Details',
        viewDetails: 'View Details',
        website: 'Website',
        month: 'Month(s)',
        year: 'Year(s)',
    },

        error: 'Error',
        success: 'Success',
        remove: 'Remove',

        plotTreeMapping: {
            title: 'Plot Tree Mapping',
            addPlotTree: 'Add Plot Tree',
            addANewRequest: 'Add a New Request',
            plot: 'Plot',
            tree: 'Tree',
            status: 'Status',
            action: 'Action',
            request: 'Plot Tree Mapping Request',
            cancelRequest: "Cancel Request",
            cancelRequestMessage: 'Are you sure you want to cancel this request? This action cannot be undone and you will be redirected to the list.',
            choosePlotLocation: 'Choose Plot Location',
            addPlotLocation: 'Add Plot Location',
            editPlotLocation: 'Edit Plot Location',
            editPlotTreeMappingRequest: 'Edit Plot Tree Mapping Request',
            chooseFarmLocation: 'Choose Farm Location',
            longitude: 'Longitude',
            latitude: 'Latitude',
            plotRadius: 'Plot Radius',
            additionalNotes: 'Additional Notes',
            searchAddress: 'Search address',
            radius: 'Radius',
            enterLongitude: 'Enter Longitude',
            enterLatitude: 'Enter Latitude',
            enterRadius: 'Enter Radius',
            farmAreaSize: 'Farm Area Size',
            errorPlotOutsideRegisteredFarm: 'This farm location is outside all registered project farms. Please choose a location within a registered farm.',
            errorCheckingFarmLocation: 'Could not verify farm location. Please try again.',
            deleteRequest: 'Delete Request',
            removePlot: 'Remove Plot',
            markAsCompleted: 'Mark as Completed',
            markAsCompletedMessage: 'Are you sure you want to mark this request as completed? You will be redirected to the list page.',
            removePlotMessage: 'Are you sure you want to remove this plot from the request?',
            confirm: 'Confirm',
            cancel: 'Cancel'
        },
        
        projectInfo: {
            title: 'Project Info',
            organizationDetail: 'Organization Detail',
            subOrganizations: 'Sub-Organizations',
            search: 'Search',
            organizations: 'Organizations',
            users: 'Users',
            registrationDate: 'Registration Date',
            close: 'Close',
            country: 'Country',
            organizationsAddress: 'Organizations Address',
            blockchainAddress: 'Blockchain Address',
            creditType: 'Credit Type',
            projectType: 'Project Type',
            officeName: 'Office Name',
            contactPersonName: 'Contact Person Name',
            contactNumber: 'Contact Number',
            email: 'Email',
            address: 'Address',
            website: 'Website',
            companyName: 'Company Name',
            companyAddress: 'Company Address',
            web: 'Website',
            vintageYear: 'Vintage Year',
            estimatedCredits: 'Estimated Credits',
            pricePerCredit: 'Price Per Credit',
            module: 'Module',
            recurring: 'Recurring',
            score: 'Score',
            approval: 'Approval',
            responsibleDimitraOffice: 'Responsible Dimitra Office',
            status: 'Status',
            standardMethodology: 'Standard/Methodology',
            validationDocumentation: 'Validation Documentation',
            creditStart: 'Credit Start',
            creditEnd: 'Credit End',
            attachmentTitle: 'Attachment(s)',
            sdgsTitle: 'Sustainable Development Goals (SDGs)',
            dataCollectionTitle: 'Data Collection Cycle',
            dataCollectionInfo: 'To participate in the Carbon Credit Program, farmers must provide historical farm data during enrollment and continue submitting periodic data updates for as long as the program remains active. This ensures accurate tracking of carbon performance over time.',
            vintage: 'Vintage',
            moduleName: 'Module Name',
            futureData: 'Future Recurring Data Collection',
            estimatedCredit: 'Estimated Credits',
        },

        user: {
            title: 'Carbon Credit User(s)',
            selectOrganization: 'Select Organization',
            project: 'Project',
            selectProject: 'Select Project',
            allUsers: 'All Users',
            activeUsers: 'Active Users',
            deactivatedUsers: 'Deactivated Users',
            pendingUsers: 'Pending Users',
            search: 'Search',
            farmerName: 'Farmer Name',
            farmName: 'Farm Name',
            organizations: 'Organizations',
            country: 'Country',
            projectTitle: 'Project Title',
            registerProject: 'Register a New Project',
            actions: 'Actions',
            noData: 'No users found.',
            view: 'View',
            viewLandPermit: 'View Land Title / Permit',
            edit: 'Edit',
            deactivate: 'Deactivate',
            deactivateConfirmation: 'Are you sure you want to deactivate this user?',
            deactivateUser: 'Deactivate User',
            activate: 'Activate',
            activateUser: 'Activate User',
            activateConfirmation: 'Are you sure you want to activate this user?',
            deactivatedSuccessfully: 'User deactivated successfully',
            activatedSuccessfully: 'User activated successfully',
            deactivationFailed: 'Failed to deactivate user',
            activationFailed: 'Failed to activate user',
            exportAsPdf: 'Export as PDF',
            projectDetails: 'Project Details',
            dateJoined: 'Date Joined',
            cropGrowingPractice: 'Crop Growing Practice',
            farm: 'Farm',
            rejectAll: 'REJECT ALL',
            acceptAll: 'ACCEPT ALL',
            confirmRejectAllTitle: 'Confirm Rejecting All Farm Requests',
            confirmRejectAll: 'You are about to reject requests for all farms to join the carbon credit project. -This action will exclude every farm submitted by the farmer in this request. Are you sure you want to proceed?',
            confirmRejectAllButton: 'Yes, Reject All',
            confirmAcceptAllTitle: 'Confirm Accepting All Farm Requests',
            confirmAcceptAll: 'You are about to accept requests for all the farms to join the carbon credit project. This action will include every farm submitted by the farmer in this request. Are you sure you want to proceed?',
            confirmAcceptAllButton: 'Yes, Accept All',
            confirmAcceptFarmTitle: 'Confirmation',
            confirmAcceptFarm: 'Are you sure you want to accept request for a farm to join project.',
            confirmAcceptFarmButton: 'Yes, Accept',
            confirmRejectFarmTitle: 'Confirmation',
            confirmRejectFarm: 'Are you sure you want to reject request for a farm to join project.',
            confirmRejectFarmButton: 'Yes, Reject',
            dateOfRegistration: 'Date of Registration',
            farmRegistrationId: 'Farm Registration ID',
            dimitraFarmId: 'Dimitra Farm ID',
            notTheFarmer: "I'm not the Farmer",
            farmerFirstName: 'Farmer First Name',
            farmerMiddleName: 'Farmer Middle Name',
            farmerLastName: 'Farmer Last Name',
            farmerRegistrationId: 'Farmer Registration ID',
            dimitraFarmerId: 'Dimitra Farmer ID',
            farmGeofence: 'Farm Geofence',
            viewGeofence: 'View Geofence',
            totalFarmSize: 'Total Farm Size',
            mainGoals: 'What are Your Main Goals',
            ownershipType: 'Ownership Type',
            certifications: 'Certification(s)',
            productionType: 'Production Type',
            landTitle: 'Land Title',
            farmLocationAddress: 'Farm Location Address',
            farmCoordinate: 'Farm Coordinate',
            farmerAgreement: 'Farmer Agreement',
            viewSignedAgreement: 'View signed agreement submitted with the application.',
            viewAgreement: 'VIEW AGREEMENT',
            acceptanceStatus: 'Acceptance Status',
            currentStatus: 'Current Status',
            reject: 'REJECT',
            accept: 'ACCEPT',
            farmActivitySubmissions: 'Farm Activity Submissions',
            farmActivitySubmissionsDesc: 'Submitted records of farming practices and updates required for carbon credit verification.',
            viewFarmData: 'VIEW FARM DATA',
            farmData: 'Farm Data',
            farmDataDesc: 'Create your reports by integrating production data from various sources. Select one or multiple sources to compile a comprehensive list of production places for your reports.',
            crops: 'Crops',
            sowing: 'Sowing',
            seedling: 'Seedling',
            fertilizer: 'Fertilizer',
            fertilizerError: 'Submission incomplete: Fertilizer information for 4 months are missing from the farmer\'s entry.',
            harvesting: 'Harvesting',
            livestock: 'Livestock',
            equipment: 'Equipment',
            projectRequests: 'Project Requests',
            userNameAndId: 'User Name & ID',
            email: 'Email',
            userRole: 'User Role',
            status: 'Status',
            userRegistrationDate: 'User Registration Date',
            pending: 'Pending',
            deactivated: 'Deactivated',
            active: 'Active',
            statusInProgress: 'In Progress',
            statusInReview: 'In Review',
            statusApprovedWithWarning: 'Approved (With Warning Sign)',
            statusApproved: 'Approved',
            statusRequireUpdate: 'Require Update',
            selectProjectTypeFirst: 'Select Project Type First',
            mandatoryInfoMissing: 'Mandatory information missing',
            farmRequestPending: 'Farm request pending',
            noFarmsToReject: 'No farms to reject',
            allFarmsAlreadyRejected: 'All farms are already rejected.',
            allFarmsRejected: 'All farms rejected successfully',
            rejectAllError: 'Failed to reject all farms',
            noFarmsToAccept: 'No farms to accept',
            allFarmsAlreadyAccepted: 'All farms are already accepted.',
            allFarmsAccepted: 'All farms accepted successfully',
            acceptAllError: 'Failed to accept all farms',
            farmNotFound: 'Farm not found or not associated with project',
            farmAlreadyRejected: 'Farm is already rejected',
            farmRejected: 'Farm rejected successfully',
            rejectFarmError: 'Failed to reject farm',
            farmAlreadyAccepted: 'Farm is already accepted',
            farmAccepted: 'Farm accepted successfully',
            acceptFarmError: 'Failed to accept farm',
            agreementOpenError: 'Failed to open agreement document',
            noSignedAgreement: 'No signed agreement has been uploaded yet.',
            uploadAgreement: 'UPLOAD AGREEMENT',
            replaceAgreement: 'REPLACE AGREEMENT',
            uploadAgreementTitle: 'Upload signed agreement',
            replaceAgreementTitle: 'Replace signed agreement',
            uploadAgreementDescription: 'Upload the signed agreement on behalf of the farmer. This will be attached to the farm\'s join request.',
            agreementUploadSuccess: 'Signed agreement uploaded successfully',
            agreementUploadError: 'Failed to upload signed agreement',
        },

        manageTrees: {
            pageTitle: 'Manage Trees',
            addNewTree: 'Add New Tree',
            updateTreeInfo: 'Update Tree Information',
            treeList: 'Tree List',
            importInBulk: 'Import in Bulk',
            downloadTrees: 'Download Trees',
            save: 'Save',
            cancel: 'Cancel',
            treeId: 'Tree ID',
            project: 'Project',
            search: 'Search',
            treeIdHeader: 'Tree ID',
            treeTypeAndSpecies: 'Tree Type & Specie',
            geoCoordinates: 'Geo Coordinates',
            addedBy: 'Added By',
            datePlanted: 'Date Planted',
            view: 'View',
            edit: 'Edit',
            delete: 'Delete',
            currentPage: 'Current Page',
            allPages: 'All Pages',
            none: 'None',
            selected: 'Selected',
            deleteTree: 'Delete Tree',
            deleteTreeConfirm: 'Are you sure you want to delete this tree? This action cannot be undone.',
            importTreesInBulk: 'Import Trees in Bulk',
            uploadCsvOrExcel: 'Upload CSV or Excel file',
            import: 'Import',
            treeDeletedSuccessfully: 'Tree deleted successfully.',
            treeDeleteFailed: 'Failed to delete tree.',
            downloadingTrees: 'Downloading selected trees...',
            importStarted: 'Import started.',
            selectAllPagesNotSupported: 'Selecting all pages is not yet supported.',
            idLabel: 'ID (E.g., tree Id)',
            additionalId: 'Additional ID',
            selectFarm: 'Select Farm',
            selectZone: 'Select Zone',
            gpsCoordinates: 'GPS Coordinates',
            gpsHint: 'e.g. 26.4443186, 87.2869355',
            locationInformation: 'Location Information',
            altitude: 'Altitude',
            seedlingName: 'Seedling Name',
            selectTreeType: 'Select Tree Type',
            selectTreeSpecies: 'Select Tree Species',
            selectHealthCondition: 'Select Health Condition',
            includeIn: 'Where Would You Like to Include This Tree?',
            additionalNotes: 'Additional Notes',
            attachImages: 'Attach Images',
            selectFilesToUpload: 'Select File(s) to Upload',
            dragAndDrop: 'or drag and drop here',
            enterHere: 'Enter here',
            makeASelection: 'Make a selection',
            avocado: 'Avocado',
            coffee: 'Coffee',
            cacao: 'Cacao',
            fruitTree: 'Fruit Tree',
            timber: 'Timber',
            other: 'Other',
            guatemalan: 'Guatemalan',
            hass: 'Hass',
            reed: 'Reed',
            fuerte: 'Fuerte',
            healthy: 'Healthy',
            moderate: 'Moderate',
            poor: 'Poor',
            dead: 'Dead',
            urban: 'Urban',
            rural: 'Rural',
            forest: 'Forest',
            farmland: 'Farmland',
            hillside: 'Hillside',
            carbonCreditProject: 'Carbon Credit Project',
            plotTreeMappingOption: 'Plot Tree Mapping',
            both: 'Both',
            fieldRequired: 'This field is required.',
            treeCreatedSuccessfully: 'Tree created successfully.',
            treeCreateFailed: 'Failed to create tree.',
            treeUpdatedSuccessfully: 'Tree updated successfully.',
            treeUpdateFailed: 'Failed to update tree.',
            treeLoadFailed: 'Failed to load tree data.',
            clusterDetails: 'Cluster Details',
            trees: 'Trees',
            primaryTreeType: 'Primary Tree Type',
            treeType: 'Tree Type',
            bulkTreeDataImport: 'Bulk Tree Data Import',
            downloadTemplateToBulkImportMessage: 'Download and use the below templates to bulk import tree.',
            selectTemplate: 'Select Template',
            bulkImportedSuccessMessage: '{count} trees have been imported successfully.',
            back: 'Back',
            treeDetails: 'Tree Details',
            treeHistory: 'Tree History',
            viewHistory: 'View History',
            provideUpdates: 'Provide Updates',
            programType: 'Program Type',
            treeImages: 'Tree Images',
            treeImage: 'Tree Image',
            treeQrCode: 'Tree QR Code',
            treeAddedBy: 'Tree Added by',
            username: 'Username',
            downloadImage: 'Download Image',
            dimitraAssetId: 'Dimitra Asset ID',
            zone: 'Zone',
            treeSpecies: 'Tree Species',
            dateOfPlantation: 'Date of Plantation',
            ageOfTree: 'Age of Tree',
            healthCondition: 'Health Condition',
            updatedBy: 'Updated By',
            updatedAt: 'Updated At',
            startDate: 'Start Date',
            endDate: 'End Date',
            whereWouldYouLikeToIncludeThisTree: 'Where Would You Like to Include This Tree?',
        },
    }
}